// extracted by mini-css-extract-plugin
module.exports = {"cardActions":"_-ui-admin-lib-CardActions-index-module__cardActions--K20Ui","right":"_-ui-admin-lib-CardActions-index-module__right--2RdUr"};